import { Action, Core } from "@faire/slate/foundation/color";

import { DEPRECATED_STOP_USING_THIS_IEmbeddedLinkTheme } from "./types";

export const DEPRECATED_STOP_USING_THIS_embeddedLinkTheme: DEPRECATED_STOP_USING_THIS_IEmbeddedLinkTheme =
  {
    base: {
      display: "inline-flex",
      "background-color": "transparent",
      "text-decoration": "underline",
      "text-decoration-color": Core.text.primary,
      color: Core.text.primary,
    },
    hover: {
      color: Action.text.hover,
      "text-decoration": "underline",
      "text-decoration-color": Action.text.hover,
    },
    disabled: {
      color: Action.text.disabled,
      "text-decoration-color": Action.text.disabled,
    },
    active: {},
  };
